import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class NFLHomePage extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="nfl"
      title="NFL Fixtures, Results & Predictions"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/NFL/containers/NFLHomePage.js